module.exports = __webpack_public_path__ + "static/media/PrivateClientsServices.eca6b722.jpg";